module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"user":"Benutzer"},"en":{"user":"User"}}')
  delete Component.options._Ctor
}
